import Repo from '../repos/Repo';

export default class SchoolRepo extends Repo{

    constructor($auth){
        super($auth, 'schools');
    }

    all(q){
        return super.all(q, "")
    }
}


// WEBPACK FOOTER //
// ./src/repos/SchoolRepo.js